import React, { PropTypes, Component } from 'react';
import classNames from 'classnames';
import { ContentStatus } from 'enums';
import WatchPropTypes from 'common/PropTypes';
import { heroImageSelector } from 'common/selectors/heroSelector';
import ResponsiveThumbnail from 'common/ResponsiveThumbnail';
import connectPlayer from 'webapp/player/connectPlayer';
import ContentMetadataLarge from 'common/page/hero/ContentMetadataLarge';
import { contentSubtitle } from '@alias/lib/format';
import { isEmpty } from 'lib/util';

const IMAGE_WIDTHS = [400, 640, 1200, 1800];

// this needs to be a class because we're connecting a player to it
class Hero extends Component {
    render() {
        const {
            content,
            selectedStream,
            playingStream,
            clickHandler,
            userIsBlackedOut,
            showLock
        } = this.props;
        const stream = !isEmpty(playingStream) ? playingStream : selectedStream;
        const { id: contentId, name: contentName, score: contentScore, status: contentStatus } = content;

        const imageHref = heroImageSelector(content);
        const { id = contentId, name = contentName, score = contentScore, status = contentStatus } = stream;
        const isPlayable = !userIsBlackedOut;
        const title = content.name;
        const subtitle = contentSubtitle(content);

        const playButtonClasses = classNames({
            'button-play button-play--video': isPlayable,
            'button-play--live': isPlayable && status === ContentStatus.LIVE
        });

        const blurredImage = (
            <ResponsiveThumbnail
                className="hero_img hero_img--blurred"
                src={imageHref}
                srcSetWidths={IMAGE_WIDTHS}
                sizes="100vw"
                alt={name}
            />
        );

        const hero = id ? (
            <article className="hero--super" data-score={score}>
                <figure className="hero_wrapper" ref="playerContainer">
                    <a className="col-a">
                        <div onClick={isPlayable && clickHandler} id={`hero-${id}`}>
                            <ResponsiveThumbnail
                                className="hero_img"
                                src={imageHref}
                                srcSetWidths={IMAGE_WIDTHS}
                                sizes="100vw"
                                alt={name}
                            />
                            <div className={playButtonClasses} />
                        </div>
                    </a>
                </figure>
                <ContentMetadataLarge
                    blurredImage={blurredImage}
                    title={title}
                    subtitle={subtitle}
                    content={content}
                    isHero
                    showLock={showLock}
                    userIsBlackedOut={userIsBlackedOut}
                />
            </article>
        ) : null;

        return <div>{hero}</div>;
    }
}

Hero.defaultProps = {
    clickHandler: (event) => {
        event.preventDefault();
    }
};

Hero.propTypes = {
    clickHandler: PropTypes.func,
    content: WatchPropTypes.content,
    selectedStream: WatchPropTypes.stream,
    playingStream: WatchPropTypes.stream,
    userIsBlackedOut: PropTypes.bool,
    showLock: PropTypes.bool
};

export default connectPlayer(Hero);



// WEBPACK FOOTER //
// ./app/webapp/page/hero/Hero.js